module.exports = __webpack_public_path__ + "static/media/microsoftazurebadge.40071ab5.png";